import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03790c1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "一级部门应收排行榜", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "二级部门应收TOP20", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "申请公司应收TOP20", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "购货单位应收TOP20", -1))

import { ref, onMounted, watch, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  showFailToast,
} from "vant";
import createWatermark from "@/utils/watermark";
import { numToMoney } from "@/utils";
import dayjs from "dayjs";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'GroupRemuneration',
  setup(__props) {

const route = useRoute();

const visible = ref(false);
// 一级部门
const oneDeptList = ref<any[]>([]);
const getOneDeptList = async () => {
  const res = await request({
    url: "/api/wx/invoice/list-finance-returned",
    method: "POST",
    data: {
      groupUnit: "one_dept",
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
    },
  });
  if (res.code === 200) {
    oneDeptList.value = res.data.list;
  } else {
    showFailToast(res.message);
  }
};
getOneDeptList();
// 二级部门
const twoDeptList = ref<any[]>([]);
const gettwoDeptList = async () => {
  const res = await request({
    url: "/api/wx/invoice/list-finance-returned",
    method: "POST",
    data: {
      groupUnit: "two_dept",
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      topNum: 20,
    },
  });
  if (res.code === 200) {
    twoDeptList.value = res.data.list;
  } else {
    showFailToast(res.message);
  }
};
gettwoDeptList();

const pageData = ref<any>({});
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/invoice/list-finance-returned",
    method: "POST",
    data: {
      groupUnit: "ask_company",
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      topNum: 20,
    },
  });
  if (res.code === 200) {
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    showFailToast(res.message);
  }
};
getPageData();

// 获取购货单位
const purchaseList = ref();
const getPurchaseList = async () => {
  const res = await request({
    url: "/api/wx/invoice/list-finance-returned",
    method: "POST",
    data: {
      groupUnit: "purchase_name",
      openId: sessionStorage.getItem("openid"),
      startDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      endDay: dayjs(route.params.time as any).format("YYYY-MM-DD"),
      topNum: 20,
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    purchaseList.value = res.data.list;
  } else {
    showFailToast(res.message);
  }
};
getPurchaseList();

const active = ref(0);

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(pageData.value.time).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Cell), {
          size: "large",
          title: "集团总应收",
          class: "bold"
        }, {
          value: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(numToMoney)(pageData.value.receivableAmount)), 1)
          ]),
          _: 1
        }),
        _hoisted_6,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "一级部门" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_unref(CellGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Cell), {
                      title: "一级部门",
                      value: "应收金额",
                      style: { background: '#E1EFF6', fontWeight: 500 }
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oneDeptList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(Cell), {
                        title: item.oneDept,
                        value: _unref(numToMoney)(item.receivableAmount),
                        key: index,
                        "title-style": { flexGrow: 3 }
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "二级部门" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_unref(CellGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Cell), {
                      title: "二级部门",
                      value: "应收金额",
                      style: { background: '#E1EFF6', fontWeight: 500 }
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(twoDeptList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(Cell), {
                        title: item.twoDept,
                        value: _unref(numToMoney)(item.receivableAmount),
                        key: index,
                        "title-style": { flexGrow: 3 }
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "申请公司" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_unref(CellGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Cell), {
                      title: "申请公司",
                      value: "应收金额",
                      style: { background: '#E1EFF6', fontWeight: 500 }
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.list, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(Cell), {
                        title: item.askCompany,
                        value: _unref(numToMoney)(item.receivableAmount),
                        key: index,
                        "title-style": { flexGrow: 3 }
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "购货单位" }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_unref(CellGroup), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Cell), {
                      title: "购货单位名称",
                      value: "应收金额",
                      style: { background: '#E1EFF6', fontWeight: 500 }
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchaseList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(Cell), {
                        title: item.purchaseName,
                        value: _unref(numToMoney)(item.receivableAmount),
                        key: index,
                        "title-style": { flexGrow: 3 }
                      }, null, 8, ["title", "value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})